<c-container class="pt-3">
    <c-row>
        <c-col class="col-lg-12">
            <c-card>
                <c-card-body>
                    <c-chart [data]="repairerSummaryData" type="line" (chartRef)="handleChartRef($event)"
                        [options]="repairerSummaryOptions" height="450" />
                </c-card-body>
            </c-card>
        </c-col>
    </c-row>
    <c-row class="mt-3">
        <c-col>
            <c-card>
             
                <c-card-body>

                    <table datatable class="table table-striped">
                        <thead>
                          <tr>
                            <th>Reg</th>
                            <th>Model</th>
                            <th>Status</th>
                            <th>VOR Reason</th>
                            <th>Last Arrived Date</th>
                            <th>Last Leave Date</th>
                            <th>Total Time at Repairer</th>
                            <th>Notes</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let vehicle of depotInsightData">
                            <td>{{ vehicle.reg }}</td>
                            <td>{{ vehicle.model }}</td>
                            <td>{{ vehicle.status }}</td>
                            <td>{{ vehicle.vorReason }}</td>
                            <td>{{ vehicle.arrivedDate }}</td>
                            <td>{{ vehicle.leaveDate }}</td>
                            <td>{{ vehicle.daysAtRepairer }}</td>
                            <td>{{ vehicle.notes }}</td>
                          </tr>
                        </tbody>
                      </table>
                      

                </c-card-body>
            </c-card>
        </c-col>

    </c-row>

</c-container>